import {Component} from '@angular/core';

@Component({
  selector: 'mz-checkbox-container',
  templateUrl: './checkbox-container.component.html',
  styleUrls: ['./checkbox-container.component.scss'],
})
export class MzCheckboxContainerComponent {
}
